<template>
  <div>
    <div class="main-ct">
      <div>
        <p class="section-title">{{ $t('Gamification_YourGames_Title') }}</p>
        <p class="section-description">
          {{ $t('Gamification_YourGames_Description') }}
        </p>
      </div>
      <div class="game-card-ct">
        <game-card
          v-for="game in games"
          :key="game.id"
          icon="check-mark"
          :status="$t('Gamification_YourGames_Status')"
          :game="game"
          card-type="active"
          @click.native="goToGameCampaignsList(game)"
        />
      </div>
    </div>
    <game-region-select-dialog
      v-if="Object.keys(selectedGame).length > 0"
      :game="selectedGame"
      :regions="selectedGame.gameRegions"
      @close="closeGameSetUpDialog"
    />
  </div>
</template>

<script>
import GameCard from '@/modules/gamification/components/games-hub-dashboard/GameCard.vue'
import GameRegionSelectDialog from '@/modules/gamification/components/games-hub-dashboard/GameRegionSelectDialog.vue'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'GamesHubYourGames',
  components: { GameRegionSelectDialog, GameCard },
  props: {
    games: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedGame: {},
      gameRegions: []
    }
  },
  methods: {
    goToGameCampaignsList(game) {
      if (game.gameRegions.length > 0 && !game.xp_backoffice_ui) {
        this.selectedGame = game
        return
      }
      if (!game.dashboard_domain) {
        this.$message.error(
          this.$t('Gamification_DashboardDomain_NotAvailable')
        )
        return
      }
      if (!game.xp_backoffice_ui) {
        this.$router.push(
          projectRoute({
            name: 'GamesHubDashboard',
            query: {
              id: game.id,
              domain: game.dashboard_domain
            }
          })
        )
        return
      }
      if (!game.dashboard_domain) {
        this.$message({
          message: this.$t('Gamification_Deprecated_Regions'),
          type: 'error'
        })
        return
      }
      this.$router.push(
        projectRoute({
          name: 'GameCampaignsList',
          params: { id: game.id }
        })
      )
    },
    closeGameSetUpDialog() {
      this.selectedGame = {}
      this.gameRegions = []
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .section-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: #4b515f;
  }

  .section-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #5c6374;
  }
}

.game-card-ct {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
}

>>> .check-mark-icon {
  color: #1fca10;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GamesHubYourGames.vue